import React from "react";

const Home: React.FC = () => {
  return (
    <div className="container-fluid">
      <div>
        <div style={{ height: "20px" }}></div>
        <p>Please send all enquiries to</p>
        <a href="mailto:admin@digswellparkconservation.co.uk">
        admin@digswellparkconservation.com
        </a><br/>
        If you have any good pictures of the area and wildlife please send them and we will use them on the site
      </div>
     
    </div>
  );
};

export default Home;
